/** Asset type selector — MUI Select populated with Accelo asset types injected at serve time. */

import { FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";

interface Choice {
  value: string;
  label: string;
}

interface Props {
  value: string;
  onChange: (value: string) => void;
  choices: Choice[];
  label?: string;
  helperText?: string;
}

export default function AssetTypeSelect({ value, onChange, choices, label = "Asset Type", helperText }: Props) {
  return (
    <FormControl fullWidth size="small">
      <InputLabel>{label}</InputLabel>
      <Select value={value} onChange={(e) => onChange(e.target.value)} label={label}>
        <MenuItem value="">
          <em>All types</em>
        </MenuItem>
        {choices.map((c) => (
          <MenuItem key={c.value} value={c.value}>
            {c.label}
          </MenuItem>
        ))}
      </Select>
      {helperText && (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, ml: 1.5 }}>
          {helperText}
        </Typography>
      )}
    </FormControl>
  );
}
